import Vue from "vue";
export default class EventBus extends Vue {
  constructor() {
    super();
    this.modules = {
      MODAL: "modal",
    };
  }
}
